import MainFrame from "../../../components/mainFrame";
import { Box, Button, IconButton } from "@mui/material";
import styled from "@emotion/styled";
import StickyTable from "../../../components/table";
import Navbar from "../../../components/navbar";
import { Cell } from "../../../components/table/styles";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/Add";
import { useModal } from "../../../components/modal";
import { DeleteModal } from "../../../components/appbar/modal";
import { smallButton } from "../../../components/Button";
import AddModal from "./modal";
import { useLocation, useNavigate } from "react-router-dom";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import {
  useDeleteQuizeMutation,
  useGetCourseQuizesQuery,
} from "../../../app/services/quize.api";
import TableRow from "@mui/material/TableRow";
import { Quize } from "../../../types/quize";
import { getLevelStr } from "../../../utils/level";
import CoursesMenuItems from "../menuItems";

const Container = styled(Box)({
  padding: "1rem",
  width: "100%",
  height: "100%",
  minHeight: "90vh",
  maxHeight: "90vh",
});
function Quizes() {
  const { setShow, setContent } = useModal();
  const {
    state: { title: courseName = "", courseId = "" },
  } = useLocation() as { state: { title: string; courseId: string } };
  const navigate = useNavigate();
  const { data, isLoading, isFetching } = useGetCourseQuizesQuery({ courseId });
  const [deleteQuize] = useDeleteQuizeMutation();

  function handleOpenModal(type: string, id?: string) {
    if (type === "edit" && id) {
      const quize = data?.entities[id];
      setContent({
        title: " ویرایش آزمون",
        body: <AddModal courseId={courseId} quize={quize} />,
      });
    }
    if (type === "add") {
      setContent({
        title: " افزودن آزمون",
        body: <AddModal courseId={courseId} />,
      });
    }
    if (type === "delete" && id) {
      setContent({
        title: "حذف آزمون",
        body: (
          <DeleteModal
            handleDelete={() =>
              deleteQuize({ courseId, quizeId: id })
                .unwrap()
                .then(() => setShow(false))
                .catch((err) => {})
            }
          />
        ),
      });
    }
    setShow(true);
  }
  return (
    <Container bgcolor="primary.light">
      <Navbar title={`آزمون های ${courseName}`}>
        <Button
          onClick={() => handleOpenModal("add")}
          sx={[
            smallButton,
            {
              color: "divider",
              borderColor: "divider",
              borderStyle: "solid",
              borderWidth: "1px",
            },
          ]}
        >
          <AddIcon />
          افزودن آزمون
        </Button>
      </Navbar>
      <StickyTable
        headers={[
          { name: "عنوان" },
          { name: "توضیحات" },
          { name: "سطح آزمون" },
          { name: "زمان (دقیقه)" },
        ]}
        length={0}
        operations={true}
        isLoading={isLoading || isFetching}
      >
        {(data?.ids || []).map((id, indx) => {
          const quize = data?.entities[id] as Quize;

          return (
            <TableRow
              hover
              role="checkbox"
              tabIndex={-1}
              key={id}
              sx={{
                "&.MuiTableRow-root": {
                  cursor: "pointer",
                },
              }}
            >
              <Cell
                sx={{
                  "&.MuiTableCell-root": {
                    color: "divider",
                    fontSize: ".8rem",
                  },
                }}
              >
                {indx + 1}
              </Cell>
              <Cell>{quize.title}</Cell>
              <Cell>{quize.desc}</Cell>
              <Cell>{getLevelStr(quize.level)}</Cell>
              <Cell>{quize.time}</Cell>
              <Cell
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton onClick={() => handleOpenModal("edit", quize._id)}>
                  <EditIcon sx={{ color: "divider" }} />
                </IconButton>
                <IconButton
                  onClick={() => handleOpenModal("delete", quize._id)}
                >
                  <DeleteIcon sx={{ color: "divider" }} />
                </IconButton>
                <IconButton
                  onClick={() =>
                    navigate(`/${courseId}/${quize._id}/questions`, {
                      state: { title: quize.title },
                    })
                  }
                >
                  <PlaylistAddIcon sx={{ color: "divider" }} />
                </IconButton>
              </Cell>
            </TableRow>
          );
        })}
      </StickyTable>
    </Container>
  );
}

export default MainFrame(Quizes, <CoursesMenuItems />);
